/* 
eslint-disable no-mixed-operators
*/
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '../../theme';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import * as componentStyling from '../styling';

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const styles = makeStyles(
	({ spacing }) => ({
		selectDropdown: {
			marginBottom: spacing(2)
		}
	})
);

const SelectList = React.memo(
	({ label, onChange, defaultValue, options=[], ...restProps }) => {
		const classes = styles();
		const [value, setValue] =  React.useState(defaultValue);
		
		let lookupValue = options.filter(o => o.value === value || o === value);
		lookupValue = lookupValue.length > 0 ? lookupValue[0] : null;
		let checkValue = lookupValue ? lookupValue : options.length && options[0] || null;
		if(checkValue && checkValue.value) checkValue = checkValue.value;
		const handleChange = (event) => setValue(event.target.value);

		React.useEffect(() => {
			checkValue && onChange && onChange(checkValue);
		}, [options, checkValue]); //eslint-disable-line react-hooks/exhaustive-deps

		const menuProps = {
			id:`${restProps.id}-menu`
		};

		return(
			<FormControl className={cx(classes.selectDropdown, componentStyling.Control)}>
				<InputLabel>{label}</InputLabel>
				<Select
					value={checkValue}
					onChange={handleChange}
					MenuProps={menuProps}
					{...restProps}
					>
					{options.map((item, i) => 
						<MenuItem 
							key={`item-${i}`} 
							value={item.value || item}>
								{item.label || item.value || item}
						</MenuItem>
					)}
				</Select>
			</FormControl>
		);
	}
);

export default SelectList;